import {useLayoutEffect,useMemo,useState} from 'react';

// Presentation only; neither the draw RNG nor purchase selection uses these
// keys. Keep a card's position across filters, draw/pool updates and scrolling.
function randomRanks(ids:string[]){
 const values=new Uint32Array(ids.length);
 for(let offset=0;offset<values.length;offset+=16384)crypto.getRandomValues(values.subarray(offset,offset+16384));
 return new Map(ids.map((id,index)=>[id,values[index]]));
}

export function useCatalogShuffle(cards:readonly {id:string}[]|undefined){
 const membership=JSON.stringify(cards?.map(card=>card.id).sort()??[]);
 const ids=useMemo(()=>JSON.parse(membership) as string[],[membership]);
 const [ranks,setRanks]=useState(()=>new Map<string,number>());
 useLayoutEffect(()=>{
  if(ranks.size===ids.length&&ids.every(id=>ranks.has(id)))return;
  const added=randomRanks(ids.filter(id=>!ranks.has(id)));
  // New membership is placed before paint; existing cards retain their keys.
  setRanks(new Map(ids.map(id=>[id,ranks.get(id)??added.get(id)!])));
 },[ids,ranks]);
 return {ranks,shuffle:()=>setRanks(randomRanks(ids))};
}
